export default "__VITE_ASSET__Bi9z7DpC__"